import { styled } from "@mui/material"
import Box from "@mui/material/Box"
import MuiCard from "@mui/material/Card"
import CardActionArea from "@mui/material/CardActionArea"
import CardContent from "@mui/material/CardContent"
import CardMedia from "@mui/material/CardMedia"
import Typography from "@mui/material/Typography"
import { tss } from "tss-react";
import AppLink from "components/navigation/AppLink"
import { Tag } from "components/tag"

interface ICard {
  imageUrl: string
  title: string
  subTitle: string
  footerText: string
  redirect: string
  coverTagText?: string
  size?: number
  height?: number
  mediaHeight?: number
  subFontSize?: number
}

const Card = (props: ICard) => {
  const {
    imageUrl,
    title,
    subTitle,
    footerText,
    redirect,
    coverTagText,
    size = 300,
    height = 360,
    mediaHeight = 180,
    subFontSize = 16,
  } = props

  const { classes } = useStyles({
    size,
    height,
    mediaHeight,
    subFontSize,
  })

  return (
    <MuiCard className={classes.root} elevation={3}>
      <CardActionArea className={classes.cardActionArea}>
        <_AppLink href={redirect} aria-label={`Open ${title}`} />
        <Box className={classes.coverBox}>
          <CardMedia image={imageUrl} className={classes.media} />
          {coverTagText && (
            <Box className={classes.coverTags}>
              <Tag preset={"error"} text={coverTagText} />
            </Box>
          )}
        </Box>
        <CardContent className={classes.cardContentContainer}>
          <Typography className={classes.subtitle}>{subTitle}</Typography>
          <Typography variant="h3" className={classes.title} gutterBottom>
            {title}
          </Typography>
          <Box className={classes.footerBox}>
            <Typography className={classes.footer}>{footerText}</Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </MuiCard>
  )
}

export default Card

// @ts-ignore
const _AppLink = styled(AppLink)(() => ({
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,

  zIndex: 2,
})) as typeof AppLink

const useStyles = tss
  .withName({ Card })
  .withParams<{
    size: number;
    height: number;
    mediaHeight: number;
    subFontSize: number;
  }>()
  .create((p) => ({
    root: {
      maxWidth: `${p.size}px`,
      minWidth: `${p.size}px`,
      minHeight: `${p.height}px`,
      margin: "20px 18px 20px 2px",
      "&.MuiPaper-rounded": {
        borderRadius: "10px",
      },
    },
    cardActionArea: {
      position: "relative",
      height: "100%",
      display: "flex",
      flexFlow: "column nowrap",
    },
    coverBox: {
      position: "relative",
      width: "100%",
    },
    coverTags: {
      position: "absolute",
      right: "0px",
      bottom: "4px",
    },
    media: {
      height: `${p.mediaHeight}px`,
      backgroundSize: "cover",
    },
    cardContentContainer: {
      width: "100%",
      minHeight: `${p.height - p.mediaHeight}px`,
      flex: 1,
      padding: "15px",
      display: "flex",
      flexFlow: "column nowrap",
    },
    subtitle: {
      fontFamily: "Lato",
      fontSize: `${p.subFontSize}px`,
      lineHeight: `${p.subFontSize + 3}px`,
      fontWeight: 400,
      color: "#262B2D",
      letterSpacing: 0,
      marginBottom: "5px",
    },
    title: {
      fontFamily: "Raleway",
      fontSize: "24px",
      lineHeight: "29px",
      fontWeight: 500,
      color: "#556064",
      letterSpacing: 0,
      wordBreak: "break-word",
    },
    footerBox: {
      marginTop: "auto",
      backgroundColor: "white",
      width: "100%",
    },
    footer: {
      fontFamily: "Lato",
      fontSize: `${p.subFontSize}px`,
      lineHeight: `${p.subFontSize + 3}px`,
      fontWeight: 400,
      color: "#556064",
      letterSpacing: 0,
      marginTop: 10,
      marginBottom: 5,
    },
  }));